import React, { FC } from 'react'

import {
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuSubContent,
} from '../../../../ui/dropdown-menu'

import { IconBanknotes } from '../../../../icons/IconBanknotes'
import { IconVenmo } from '../../../../icons/IconVenmo'
import { IconPayPal } from '../../../../icons/IconPayPal'

import { IPaymentType, PAYMENT_TYPE } from '../../../../../types/payment'

interface MarkPaidByCashOptionsProps {
  setLoading: (loading: boolean) => void
  onMarkPaidAction: (values: {
    type: IPaymentType
    checkNumber?: string
    checkMemo?: string
  }) => Promise<void>
}
export const MarkPaidByCashOptions: FC<MarkPaidByCashOptionsProps> = ({
  setLoading,
  onMarkPaidAction,
}) => {
  return (
    <DropdownMenuPortal>
      <DropdownMenuSubContent className="w-[260px] direction-ltr">
        <DropdownMenuItem
          onClick={async () => {
            setLoading(true)
            await onMarkPaidAction({ type: PAYMENT_TYPE.CASH })
            setLoading(false)
          }}
          className="cursor-pointer hover:underline"
        >
          <IconBanknotes className="w-[12px] fill-black" />
          Cash
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={async () => {
            setLoading(true)
            await onMarkPaidAction({ type: PAYMENT_TYPE.VENMO })
            setLoading(false)
          }}
          className="cursor-pointer hover:underline"
        >
          <IconVenmo className="w-[12px]" />
          Venmo
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={async () => {
            setLoading(true)
            await onMarkPaidAction({ type: PAYMENT_TYPE.PAYPAL })
            setLoading(false)
          }}
          className="cursor-pointer hover:underline"
        >
          <IconPayPal className="w-[12px]" />
          PayPal
        </DropdownMenuItem>
      </DropdownMenuSubContent>
    </DropdownMenuPortal>
  )
}
